import { render, staticRenderFns } from "./AddCompanyNotification.vue?vue&type=template&id=3321cce2&"
import script from "./AddCompanyNotification.vue?vue&type=script&lang=js&"
export * from "./AddCompanyNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyNotification.vue?vue&type=style&index=0&id=3321cce2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports